import React from 'react';

export default function PageHeader({ title, description, actions }: {
  title: React.ReactNode; description?: React.ReactNode; actions?: React.ReactNode;
}) {
  return <header className="page-header">
    <div className="min-w-0"><h1 className="flex items-center gap-3 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">{title}</h1>
      {description && <div className="mt-2 max-w-3xl text-sm leading-6 text-gray-600">{description}</div>}
    </div>
    {actions && <div className="flex shrink-0 flex-wrap items-center gap-3">{actions}</div>}
  </header>;
}
